<template>
  <el-container>
    <el-dialog
        :visible.sync="dialogVisible"
        @opened="loginDialogOpened"
        :before-close="handleClose">
      <div
          style="width: 100%;height: 450px; overflow: auto; padding-top:30px;display: flex;flex-direction: column;flex-wrap:wrap;justify-content:flex-start;align-items:center;">
        <div style="font-size: 22px;color: #333333;">微信扫码登录存图帮</div>
        <canvas ref="login_qrcode" style="width:180px;height:180px;margin-top:30px;border: 1px #DDDDDD solid"></canvas>
        <div style="width: 100%;">
          <el-divider>登录说明</el-divider>
        </div>
        <div style="width:450px;padding: 0 10px;font-size: 14px;line-height: 16px; color: #333333;">
          •使用微信扫码后关注微信服务号【存图帮】即可登录。<br/><br/>
          •扫码登录表示您同意我们的
          <el-link type="primary" href="/UserAgreement.html" target="_blank" style="vertical-align: baseline;">用户协议
          </el-link>
          和
          <el-link type="primary" href="/PrivacyPolicy.html" target="_blank" style="vertical-align: baseline;">隐私政策
          </el-link>
          <br/><br/>
          •同一微信账号使用存图帮服务号、存图帮网页版与怪味萌图小程序，用户数据与会员通用。<br/><br/>
          （因网页版限制，需要关注服务号才能登录，因此请扫码关注后使用）
        </div>
      </div>
    </el-dialog>
    <el-dialog
        :visible.sync="buyVipDialogVisible"
        @opened="buyVipDialogOpened"
        :before-close="handleBuyVipClose">
      <div
          style="width: 100%;height: 610px; overflow: auto; padding:0 0 30px 0;display: flex;flex-direction: column;justify-content:flex-start;align-items:center;">
        <div style="font-size: 22px;color: #333333;">开通会员</div>
        <!--选择会员-->
        <div v-for="vipItem in vipItemList">
          <div style="height: 40px; line-height: 20px; margin-top: 20px; display: flex; flex-direction: row; flex-wrap: wrap; justify-content: flex-start; align-items: center;">
            <div style="height: 30px; width: 5px; background: #F44336;"></div>
            <div>
              <div class="month-vip-title">{{vipItem.vipTitle}}</div>
              <div class="month-vip-sub-title">{{vipItem.vipSubTitle}}</div>
            </div>
          </div>
          <div class="month-vip-items">
            <div v-for="item in vipItem.vipList" :class="selectedVipType==item.code?'month-vip-item-choose':'month-vip-item'" @click="selectVipType(item.code)">
              <div :class="selectedVipType==item.code?'month-vip-text-time-choose':'month-vip-text-time'">
                {{item.title}}
              </div>
              <div style="flex: 1; display: flex; flex-direction: column; justify-content: center; align-items: center;">
                <div class="month-vip-text-recommend">
                  {{item.recommendText}}
                </div>
                <div class="month-vip-text-money">
                  {{item.priceDesc}}
                </div>
                <div class="month-vip-text-orig">
                  <span v-if="item.origPriceStr">原价{{item.origPriceStr}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="width: 400px; margin-top:10px;font-size: 12px; line-height: 16px;"><span
            style="font-weight: 600;color: #F44336;">已选：</span><span v-html="vipDesc"></span></div>
        <canvas ref="pay_qrcode" style="width:150px;height:150px;margin-top:20px;border: 1px #DDDDDD solid"></canvas>
        <div class="wechat-pay-items" style="margin-top:10px;">
          <div class="wechat-pay-item-choose">
            <div
                style="font-size: 12px;color:#333333;display: flex;flex-direction: row;flex-wrap:wrap;justify-content: space-around;align-items:center;line-height: 1.2;">
              <i style="color: #09BB07;font-size: 14px;" class="iconfont iconweixinzhifu"></i>
              微信支付
            </div>
          </div>
        </div>

        <div style="width: 100%;">
          <el-divider>开通会员须知</el-divider>
        </div>
        <div class="buy-know-text-area">{{vipInfo}}</div>
      </div>
    </el-dialog>
    <el-dialog
        :visible.sync="contactServiceDialogVisible">
      <div
          style="width: 100%;display: flex;flex-direction: column;flex-wrap:wrap;justify-content:flex-start;align-items:center;">
        <!--<div style="font-size: 22px;color: #333333;">请通过小程序联系客服</div>-->
        <img style="width:400px;height:400px;" src="../assets/kefu.png">
        <!--<div style="width:400px;margin:30px 0;font-size: 14px;line-height: 16px;color: #333333;">
            扫码进入【存图帮】公众号，发送<span style="font-weight: 600;">“人工客服”</span>即可联系我们
        </div>-->
      </div>
    </el-dialog>
    <el-dialog
        customClass="app-download-dialog"
        :visible.sync="downloadAppDialogVisible">
      <div
          style="display: flex;flex-direction: column;flex-wrap:wrap;justify-content:flex-start;align-items:flex-start;padding: 170px 0 0 32px;color: #444444;">
        <div style="font-size: 30px;font-weight: 500;">存图帮APP</div>
        <div style="margin-top:12px;font-size: 19px;">
          现已推出<span style="font-weight: bold; color: #443388">Windows</span>和<span style="font-weight: bold; color: #443388">macOS</span>客户端<br>用客户端存图更快更方便
        </div>
        <div
            style="margin-top:72px;display: flex;flex-direction: row;flex-wrap:wrap;justify-content:center;align-items:center;">
          <el-link :underline="false" @click="iosDownload"
                   style="width: 120px; height: 40px;font-size: 14px; border: #444444 2px solid;border-radius: 20px;text-align: center;line-height: 40px;margin-right: 16px;">
            <i class="iconfont iconios"></i>
            iOS
          </el-link>
          <el-link :underline="false" @click="androidDownload"
                   style="width: 120px; height: 40px;font-size: 14px; border: #444444 2px solid;border-radius: 20px;text-align: center;line-height: 40px;">
            <i class="iconfont iconandroid"></i>
            Android
          </el-link>
        </div>
        <div
            style="margin-top:32px;display: flex;flex-direction: row;flex-wrap:wrap;justify-content:center;align-items:center;">
          <el-link :underline="false" @click="macOSDownload"
                   style="width: 120px; height: 40px;font-size: 14px; border: #444444 2px solid;border-radius: 20px;text-align: center;line-height: 40px;margin-right: 16px;">
            <i class="iconfont iconios"></i>
            macOS
          </el-link>
          <el-link :underline="false" @click="windowsDownload"
                   style="width: 120px; height: 40px;font-size: 14px; border: #444444 2px solid;border-radius: 20px;text-align: center;line-height: 40px;margin-right: 16px;">
            <i class="iconfont iconwindows"></i>
            Windows
          </el-link>
        </div>
        <div
            style="margin-top:32px;display: flex;flex-direction: row;flex-wrap:wrap;justify-content:center;align-items:center;">
          <el-popover
              placement="top-start"
              trigger="hover">
            <div style="text-align: left; margin: 0">
              <img style="width:200px;height:200px;" src="../assets/download_app_qrcode.png">
            </div>
            <el-link :underline="false" slot="reference"
                     style="width: 140px; height: 40px;font-size: 14px; border: #444444 2px solid;border-radius: 20px;text-align: center;line-height: 40px;">
              <i class="iconfont iconerweima"></i>
              手机扫码下载
            </el-link>
          </el-popover>
        </div>
      </div>
    </el-dialog>
    <el-dialog
        :visible.sync="useTutorialDialogVisible">
      <div
          style="width: 100%;padding-top:30px;display: flex;flex-direction: column;flex-wrap:wrap;justify-content:flex-start;align-items:center;">
        <div style="font-size: 22px;color: #333333;">使用教程</div>
        <div style="width:400px;margin:30px 0;font-size: 14px;line-height: 16px;color: #333333;">
          1.在各平台APP中复制或分享链接。<br/>
          2.粘贴到存图帮的输入框中。<br/>
          3.点击“获取资源”按钮。<br/>
          4.保存获取到的视频和图片。
        </div>
      </div>
    </el-dialog>
    <el-dialog
        title="提示"
        :visible.sync="useOutDialogVisible">
      <div style="font-size: 16px;padding: 20px;color: #333333;">{{ useOutMessage }}，如想继续使用请开通会员</div>
      <span slot="footer" class="dialog-footer">
                <el-button @click="useOutDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="useOutBuyVip">开通会员</el-button>
        </span>
    </el-dialog>
    <el-dialog
        :title="warningDialogTitle"
        :visible.sync="warningDialogVisible">
      <div style="font-size: 16px;padding: 20px;color: #333333;" v-html="warningDialogContent"></div>
      <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="warningDialogVisible = false">确 定</el-button>
            </span>
    </el-dialog>
    <el-header direction="horizontal">
      <el-link v-if="!isIndex" @click="goIndex" :underline="false" style="float: left;">
        <div style="display: flex;flex-direction: row;flex-wrap:wrap;justify-content:center;align-items:center;">
          <img style="width: 32px;height: 32px;border-radius: 16px;" src="../assets/logo.png">
          <div style="display:inline; font-size: 20px;margin-left: 5px;">存图帮</div>
        </div>
      </el-link>
      <el-input
          v-if="!isIndex"
          placeholder="在此粘贴复制的链接"
          v-model="urlInput"
          clearable
          @focus="inputFocus"
          @keyup.enter.native="requestAllResource"
          style="width: 350px;float: left; border: none; line-height: 1;top: 50%;margin: -20px 0 0 50px;">
        <el-button
            slot="append"
            type="primary"
            icon="el-icon-search"
            style="border: none;"
            :loading="loading"
            @click="requestAllResource">
        </el-button>
      </el-input>

      <div style="position: relative;width:120px;height:100%;float: right;">
        <el-button v-if="unionId == null" round size="small" type="primary" @click="dialogVisible = true">登录/注册
        </el-button>
        <div v-else style="width: 100%;height: 100%;">
          <el-avatar style="line-height: 28px;height: 28px;position: absolute;top: 50%;margin: -14px 0 0 0;"
                     size="small" :src="headImgUrl"></el-avatar>
          <el-popover
              placement="bottom"
              width="100"
              trigger="hover">
            <div style="text-align: left; margin: 0">
              <span style="display: block;font-size: 16px;font-weight: 800;">Hi, {{ nickName }}(ID:{{ userId }})</span>
              <span v-if="userStatusDesc" style="display: block;margin-top: 5px;">{{ userStatusDesc }}</span>
              <span v-if="vipExpireDesc" style="display: block;margin-top: 5px;">{{ vipExpireDesc }}</span>
              <el-link :underline="false" style="width: 100%;height: 30px;margin-top: 10px;justify-content: left;"
                       @click="userLogout"><i style="font-size: 14px;" class="iconfont icontuichudenglu"></i>退出登录
              </el-link>
            </div>
            <el-link :underline="false" slot="reference"
                     style="font-size:14px;line-height: 28px;height: 28px;margin-left: 30px;">个人中心<i
                class="el-icon-caret-bottom"></i></el-link>
          </el-popover>

        </div>
      </div>
      <div style="width:420px;float: right;">
        <el-link :underline="false" style="padding: 0 5px;color: #409EFF" @click="goIndex">首页</el-link>
        <el-divider direction="vertical"></el-divider>
        <el-link :underline="false" style="padding: 0 5px;" @click="buyVip">开通会员</el-link>
        <el-divider direction="vertical"></el-divider>
        <el-link :underline="false" style="padding: 0 5px;" @click="downloadApp">下载客户端</el-link>
        <el-divider direction="vertical"></el-divider>
        <el-link :underline="false" style="padding: 0 5px;" @click="useTutorialDialogVisible = true">使用教程</el-link>
        <el-divider direction="vertical"></el-divider>
        <el-link :underline="false" style="padding: 0 5px;" @click="contactServiceDialogVisible = true">联系客服</el-link>
      </div>
    </el-header>
    <el-main v-loading="loading">
      <div
          style="margin-top: 20vh;height: 50px;display: flex;flex-direction: row;flex-wrap:wrap;justify-content:center;align-items:center;"
          v-if="isIndex">
        <img style="width: 50px;height: 50px;border-radius: 25px;" src="../assets/logo.png">
        <div style="font-size: 40px;margin-left: 5px;">存图帮</div>
      </div>
      <el-input
          v-if="isIndex"
          style="width: 500px;line-height: 1;margin-top: 5vh;"
          placeholder="在此粘贴复制的链接"
          v-model="urlInput"
          clearable
          @focus="inputFocus"
          @keyup.enter.native="requestAllResource">
        <el-button
            slot="append"
            type="primary"
            :loading="loading"
            @click="requestAllResource">
          获取素材
        </el-button>
      </el-input>

      <!--展示获取到的资源-->
      <div
          style="width:100%; margin-top: 10px; height: 100%; display: flex; flex-direction: row;flex-wrap: wrap;justify-content: center;align-items: flex-start">
        <div v-if="videoList != null && videoList.length > 0" v-bind:style="{flex: videoFlex}"
             style="min-width: 260px;">
          <div class="res-type">视频资源</div>
          <div
              style="width:100%; margin-top: 5px; display: flex;flex-direction: row;flex-wrap: wrap;justify-content: center;align-items: center">
            <div v-for="(video, index) in videoList" :key="index" style="margin:5px; ">
              <video :src="video.url" controls="controls"
                     style="width: 150px;height: 150px;display: block;box-shadow: 0 0 3px #333333;"></video>
              <el-button
                  @click="downloadVideo(video)"
                  type="primary"
                  size="small"
                  class="download-video"
                  icon="el-icon-download">下载
              </el-button>
            </div>
          </div>
        </div>
        <div v-if="imgItemList != null && imgItemList.length > 0" v-bind:style="{flex: imgFlex}"
             style="position: relative; min-width:400px;border-width:1px; border-style: none solid;border-color: #cccccc;">
          <div class="res-type">图片资源</div>
          <div
              style="width:100%; margin:5px; display: flex;flex-direction: row;flex-wrap: wrap;justify-content: center; align-items: center;">
            <div v-for="(imgItem, index) in imgItemList" :key="index" class="img-item">
              <el-image
                  style="width: 100%; height: 100%;position: absolute;top: 0;left: 0;"
                  fit="cover"
                  :src="imgItem.url"
                  :preview-src-list="imgUrlList">
              </el-image>
              <i class="el-icon-success" style="text-shadow: 0 0 3px #000000;"
                 v-bind:class="{ 'checked-icon': imgItemList[index].checked, 'unchecked-icon': !imgItemList[index].checked }"
                 @click="imgItemList[index].checked = !imgItemList[index].checked"></i>
              <el-button type="primary" @click="downloadByGetBlob(imgItem)"
                         style="position: absolute;left: 3px;top: 3px;font-size: 10px; padding: 3px 5px;">下载
              </el-button>
            </div>
          </div>
          <el-button
              type="primary"
              size="small"
              :loading="isPackageDownloading"
              @click="packageDownload"
              icon="el-icon-box"
              style="width: 200px;margin-top: 20px;">
            打包下载
          </el-button>
        </div>
        <div v-if="descList != null && descList.length > 0" style="width: 260px;">
          <div class="res-type">文字资源</div>
          <div v-for="(desc, index) in descList" :key="index"
               style="width:100%; margin-top: 5px; display: flex;flex-direction: row;flex-wrap: wrap;justify-content: center;align-items: center">

            <el-input
                style="width: 250px; display: block;"
                type="textarea"
                :autosize="{ minRows: 5, maxRows: 20}"
                placeholder="请输入内容"
                v-model="descList[index]">
            </el-input>
            <div style="width: 250px;" class="hint-text">*可以直接在文本框中进行编，编辑后的内容可以点击按钮复制</div>
            <el-button type="primary" size="small" icon="el-icon-document-copy" class="copy-text"
                       :data-clipboard-text="desc">复制文案
            </el-button>

          </div>
        </div>
      </div>
    </el-main>
    <el-footer style="height: 50px;position: fixed;bottom: 0;font-size: 16px">
      <span>Copyright © 2019 - 2020 闻绘科技 All Rights Reserved.&nbsp;&nbsp;&nbsp;</span>
      <a href="http://beian.miit.gov.cn/" target="_blank"
         style="width: 200px;margin: 0 auto;color: #BBBBBB;text-decoration: none;">浙ICP备19046223号-2<br></a>
    </el-footer>
  </el-container>
</template>

<script>
import {mapState, mapMutations} from "vuex";
import QRCode from "qrcode";
import Clipboard from 'clipboard';
import md5 from 'blueimp-md5';

export default {
  name: "Home",
  data() {
    return {
      activeIndex: 0,
      select: 1,
      urlInput: "",
      dialogVisible: false,
      useOutMessage: '',
      useOutDialogVisible: false,
      buyVipDialogVisible: false,
      contactServiceDialogVisible: false,
      downloadAppDialogVisible: false,
      useTutorialDialogVisible: false,
      warningDialogVisible: false,
      warningDialogTitle: null,
      warningDialogContent: null,
      loginCodeUrl: null,
      payCodeUrl: null,
      expireTime: null,
      descList: [],
      imgItemList: [],
      imgUrlList: [],
      videoList: [],
      resourceType: 100,
      resourceTimestamp: null,
      webProxyUrl: null,
      loading: false,
      isIndex: true,
      isPackageDownloading: false,
      selectedVipType: '',
      vipPrice: '',
      vipDesc: '',
      vipInfo: '',
      vipItemList: [],
      supPlatformList: [],
      contentTypeSuffix: {
        "image/jpeg": ".jpg",
        "image/png": ".png",
        "image/gif": ".gif",
        "image/webp": ".webp",
        "video/mp4": ".mp4",
        "audio/mpeg": ".mp3"
      }
    }
  },
  computed: {
    ...mapState("ui", ["showHeaderBar", "showBottomNav", "transBackground"]),
    ...mapState("user", ["unionId", "userId", "nickName", "headImgUrl", "freeBalance", "timesVipBalance", "monthVipExpire", "userStatusDesc", "vipExpireDesc"]),
    ...mapState("data", ["virtualData"]),
    videoFlex() {
      if (this.videoList.length <= 3) {
        return 1;
      } else {
        return this.videoList.length;
      }
    },
    imgFlex() {
      if (this.imgItemList.length <= 3) {
        return 1;
      } else {
        return this.imgItemList.length / 2.0;
      }
    },
    hasResult() {
      return this.videoList.length > 0 || this.imgItemList.length > 0 || this.descList.length > 0;
    },
  },
  components: {},
  methods: {
    loginDialogOpened() {
      //打开登录对话框时，生成登录二维码
      let that = this;
      this.$api
          .post("CwHelper/loginQrCode", {})
          .then(response => {
            //console.log(response);
            if (response.data.resultCode === 0) {
              that.loginCodeUrl = response.data.codeUrl;
              that.expireTime = response.data.expireTime;
              QRCode.toCanvas(that.$refs.login_qrcode, response.data.codeUrl, {width: 180});
              that.queryLoginResult();//开始查询扫码结果
            } else {
              //登录二维码生成失败
              //console.log("登录二维码生成失败");
              this.showWarningDialog("提示", "登录二维码生成失败");
            }
          })
          .catch(error => {
            //生成二维码请求失败
            //console.log(error);
            this.showWarningDialog("提示", "登录二维码生成失败");
          });
    },
    buyVipDialogOpened() {
      //打开购买会员对话框
      this.getVipList();
    },
    selectVipType: function (vipType) {
      this.payCodeUrl = null;
      this.$refs.pay_qrcode.getContext("2d").clearRect(0, 0, this.$refs.pay_qrcode.width, this.$refs.pay_qrcode.height);
      var vipDesc = '', vipPrice = '';
      vip_item_loop:
      for (let i = 0; i < this.vipItemList.length; i++) {
        let vipItem = this.vipItemList[i];
        let vipList = vipItem.vipList;
        for (let j = 0; j < vipList.length; j++) {
          let vip = vipList[j];
          if (vip.code === vipType) {
            vipPrice = vip.priceStr;
            vipDesc = vip.orderDesc;
            break vip_item_loop;
          }
        }
      }
      this.selectedVipType = vipType;
      this.vipPrice = vipPrice;
      this.vipDesc = vipDesc;
      this.buyVipUnion();
    },
    buyVip() {
      let that = this;
      that.buyVipDialogVisible = true;
    },
    buyVipUnion() {
      let that = this;
      if (this.unionId == null || this.unionId.length === 0) {
        that.buyVipDialogVisible = false;
        this.showWarningDialog("提示", "请先登录再开通会员！")
        return;
      }
      this.$api
          .post("CwHelper/buyVipUnion", {
            unionId: that.unionId,
            orderType: that.selectedVipType,
            from: 3
          })
          .then(response => {
            //console.log(response);
            if (response.data.resultCode === 0) {
              that.payCodeUrl = response.data.codeUrl;
              QRCode.toCanvas(that.$refs.pay_qrcode, that.payCodeUrl, {width: 150});
              that.queryPayResult();//开始查询付款结果
            } else if (response.data.resultCode === 6) {
              //会员未到期
              that.buyVipDialogVisible = false;
              that.showWarningDialog("提示", response.data.resultMsg);
            } else if (response.data.resultCode === 7) {
              //需要刷新页面
              that.buyVipDialogVisible = false;
              that.showWarningDialog("提示", res.data.resultMsg);
            } else {
              //登录二维码生成失败
              that.buyVipDialogVisible = false;
              that.showWarningDialog("提示", "购买会员二维码生成失败");
            }
          })
          .catch(error => {
            //生成二维码请求失败
            that.buyVipDialogVisible = false;
            that.showWarningDialog("提示", "购买会员二维码生成失败");
          });
    },
    //下载App
    downloadApp() {
      this.downloadAppDialogVisible = true;
      // let routeData = this.$router.resolve({
      //     path: "/app",
      // });
      // window.open(routeData.href, '_blank');
    },
    showWarningDialog(title, content) {
      this.warningDialogTitle = title;
      this.warningDialogContent = content;
      this.warningDialogVisible = true;
    },
    queryLoginResult() {
      //查询是否已经扫码成功
      let that = this;
      this.$api
          .post("CwHelper/qrCodeLoginResult", {
            codeUrl: that.loginCodeUrl
          })
          .then(response => {
            //console.log(response);
            if (response.data.resultCode === 0) {
              //已扫码登录
              that.setLogin(response.data);
              that.queryUserInfo();
              that.handleClose();
            } else {
              //未扫码登录
              if (that.dialogVisible) {
                setTimeout(function () {
                  that.queryLoginResult();
                }, 200);
              }
            }
          })
          .catch(error => {
            //查询请求失败  1秒后再次查询
            if (that.dialogVisible) {
              setTimeout(function () {
                that.queryLoginResult();
              }, 1000);
            }
          });
    },
    queryPayResult() {
      //查询会员支付结果
      let that = this;
      this.$api
          .post("CwHelper/queryPayResult", {
            codeUrl: that.payCodeUrl
          })
          .then(response => {
            //console.log(response);
            if (response.data.resultCode === 0) {
              //判断付款结果
              if (response.data.payResultCode === 3) {
                that.handleBuyVipClose();
                that.showWarningDialog('通知', '付款成功，会员已开通！');
              } else {
                if (that.buyVipDialogVisible) {
                  setTimeout(function () {
                    that.queryPayResult();
                  }, 200);
                }
              }
            } else {
              //未扫码登录
              if (that.buyVipDialogVisible) {
                setTimeout(function () {
                  that.queryPayResult();
                }, 200);
              }
            }
          })
          .catch(error => {
            //查询请求失败  1秒后再次查询
            if (that.buyVipDialogVisible) {
              setTimeout(function () {
                that.queryPayResult();
              }, 1000);
            }
          });
    },
    //用户登录对话框关闭
    handleClose() {
      //清空画布
      this.loginCodeUrl = null;
      this.$refs.login_qrcode.getContext("2d").clearRect(0, 0, this.$refs.login_qrcode.width, this.$refs.login_qrcode.height);
      this.dialogVisible = false;
    },
    //购买会员对话框关闭
    handleBuyVipClose() {
      this.payCodeUrl = null;
      this.$refs.pay_qrcode.getContext("2d").clearRect(0, 0, this.$refs.pay_qrcode.width, this.$refs.pay_qrcode.height);
      this.buyVipDialogVisible = false;
    },
    //次数用尽后购买vip
    useOutBuyVip() {
      this.useOutDialogVisible = false;
      this.buyVip();
    },
    //查询用户信息
    queryUserInfo() {
      let that = this;
      if (this.unionId != null && this.unionId.length > 0) {
        this.$api
            .post("CwHelper/cwUserStatus", {
              unionId: that.unionId
            })
            .then(response => {
              //console.log(response);
              if (response.data.resultCode === 0) {
                that.updateUserInfo(response.data);
              } else {
                //用户信息更新失败
              }
            })
            .catch(error => {
              //用户信息更新失败
            });
      }
    },
    getVipList: function(){
      let that = this;
      this.$api.post("CwHelper/getVipList", {
        unionId: this.unionId,
        from: 3
      }).then(function(res) {
        if (res.data.resultCode == 0) {
          that.vipInfo = res.data.vipInfo;
          that.vipItemList = res.data.vipItemList;
          that.selectVipType(res.data.defaultVip);
        }
      }).catch(function(err) {
        console.log(err)
      });
    },
    //获取配置信息
    queryActivity() {
      let that = this;
      this.$api
          .post("CwHelper/cwactivity", {})
          .then(response => {
            //console.log(response);
            if (response.data.resultCode === 0) {
              that.supPlatformList = response.data.config.supPlatformList;
              this.supPlatformList.push({
                platformIcon: require('@/assets/next_app.png'),
                platformName: '更多平台接入中'
              });
            } else {
              //用户信息更新失败
            }
          })
          .catch(error => {
            //用户信息更新失败
          });
    },
    //用户退出登录
    userLogout() {
      //console.log(this.unionId);
      this.goIndex();
      this.setLogout();
    },
    //请求解析链接
    requestAllResource() {
      let that = this;
      if (this.unionId == null || this.unionId.length === 0) {
        //需要先登录
        this.dialogVisible = true;
        return;
      }
      if (this.urlInput == null || this.urlInput.length === 0) {
        this.$alert('请输入或粘贴链接', '提示', {
          confirmButtonText: '确定',
          callback: action => {
            //啥都不做
          }
        });
        return;
      }
      this.isIndex = false;
      this.loading = true;
      this.descList = [];
      this.imgItemList = [];
      this.imgUrlList = [];
      this.videoList = [];
      this.resourceType = 100;
      this.resourceTimestamp = null;
      this.webProxyUrl = null;
      this.$api
          .post("CwHelper/allResourceV3", {
            webUrl: that.urlInput,
            unionId: that.unionId,
            from: 3
          })
          .then(response => {
            this.loading = false;
            if (response.data.resultCode === 0) {
              //解析成功
              that.decodeResource(response);
              that.queryUserInfo();
            } else if (response.data.resultCode === 5) {
              //次数用尽
              that.useOutMessage = response.data.resultMsg;
              that.useOutDialogVisible = true;
            } else {
              that.showWarningDialog("提示", response.data.resultMsg || "解析失败");
            }
          })
          .catch(error => {
            this.loading = false;
            that.showWarningDialog("提示", "解析失败");
          });
    },
    decodeResource: function (res) {
      var descList = res.data.descList;
      var imgList = res.data.imgList;
      var videoList = res.data.videoList;
      this.resourceType = res.data.resourceType;
      this.resourceTimestamp = res.data.timestamp;
      this.webProxyUrl = res.data.webProxyUrl;
      //判断是否有文本内容
      if (descList != null && descList.length > 0) {
        this.descList = descList;
      }
      //判断是否有图片内容
      if (imgList != null && imgList.length > 0) {
        for (var i = 0, len = imgList.length; i < len; i++) {
          this.imgItemList.push({
            checked: true,
            url: imgList[i].url,
            imgHash: imgList[i].imgHash,
          });
          this.imgUrlList.push(imgList[i].url)
        }
      }
      //判断是否有视频内容
      if (videoList != null && videoList.length > 0) {
        for (var i = 0, len = videoList.length; i < len; i++) {
          this.videoList.push({
            url: videoList[i].url,
            videoHash: videoList[i].videoHash,
          });
        }
      }
    },
    //下载视频
    downloadVideo(video) {
      let proxyUrl = this.getProxyUrl(video.url, video.videoHash);
      this.downloadFile(proxyUrl, "");
    },
    //打包下载图片
    packageDownload() {
      let that = this;
      let urlHashList = [];
      for (let i = 0; i < that.imgItemList.length; i++) {
        if (that.imgItemList[i].checked) {
          urlHashList.push({
            url: that.imgItemList[i].url,
            hash: that.imgItemList[i].imgHash,
          });
        }
      }
      if (urlHashList.length === 0) {
        that.$alert('请选择要下载的图片', '提示', {
          confirmButtonText: '确定',
          callback: action => {
            //啥都不做
          }
        });
        return;
      }
      this.isPackageDownloading = true;
      this.$api
          .post(this.webProxyUrl + "/res/zip", {
            urlHashList: urlHashList,
            timestamp: that.resourceTimestamp,
            resourceType: that.resourceType
          })
          .then(response => {
            that.isPackageDownloading = false;
            if (response.data.resultCode === 0) {
              that.downloadFile(that.webProxyUrl + "/static/" + response.data.zipFileUrl, "");
            } else {
              //打包下载失败
              that.$message({
                message: '打包下载失败',
                type: 'error',
                duration: 1000,
                showClose: true
              });
            }
          }).catch(error => {
        //打包下载失败
        that.isPackageDownloading = false;
        that.$message({
          message: '打包下载失败',
          type: 'error',
          duration: 1000,
          showClose: true
        });
      });
    },
    downloadByGetBlob(image) {
      let proxyUrl = this.getProxyUrl(image.url, image.imgHash);
      this.downloadFile(proxyUrl, "");
    },
    //下载文件
    downloadFile(url, fileName) {
      // 创建隐藏的可下载链接
      var eleLink = document.createElement('a');
      eleLink.download = fileName;
      eleLink.style.display = 'none';
      eleLink.href = url;
      // 触发点击
      document.body.appendChild(eleLink);
      eleLink.click();
      // 然后移除
      document.body.removeChild(eleLink);
    },
    getProxyUrl(url, hash) {
      return this.webProxyUrl + "/res/dl?url=" + encodeURIComponent(url) + "&hash=" + hash + "&timestamp=" + this.resourceTimestamp;
    },
    //输入框获取焦点时全选
    inputFocus(event) {
      event.currentTarget.select();
    },
    //下载图片时的文件名
    downloadFileName(url) {
      return md5(url) + '.jpg';
    },
    downloadVideoFileName(url) {
      return md5(url) + '.mp4';
    },
    androidDownload() {
      window.open('https://dl1.cuntubang.com/app/ctb1.13.23.apk', '_blank');
    },
    iosDownload() {
      window.open('https://apps.apple.com/cn/app/id1522857489', '_blank');
    },
    macOSDownload() {
      window.open('https://dl1.cuntubang.com/desktop/%E5%AD%98%E5%9B%BE%E5%B8%AEv1.13.23.dmg', '_blank');
    },
    windowsDownload() {
      window.open('https://dl1.cuntubang.com/desktop/%E5%AD%98%E5%9B%BE%E5%B8%AEv1.13.23.exe', '_blank');
    },
    //去首页
    goIndex() {
      this.isIndex = true;
      this.loading = false;
      this.urlInput = '';
      this.descList = [];
      this.imgItemList = [];
      this.imgUrlList = [];
      this.videoList = [];
    },
    ...mapMutations("user", {
      setLogin: "login",
      updateUserInfo: "updateUserInfo",
      setLogout: "logout",
    }),
  },
  created() {
    //created
  },
  mounted() {
    let that = this;
    const clipboard = new Clipboard('.copy-text');
    clipboard.on('success', function (e) {
      that.$message({
        message: '复制成功',
        type: 'success',
        duration: 1000,
        showClose: true
      });
    });
    clipboard.on('error', function (e) {
      that.$message.error({
        message: '复制失败',
        duration: 1000,
        showClose: true
      });
    });
    //查询用户信息
    this.queryUserInfo();
    //获取配置信息
    this.queryActivity();
    //展示下载APP弹窗
    let now = new Date().getTime();
    let lastShowTime = window.localStorage.getItem("download_app_dialog");
    if (!lastShowTime) {
      this.downloadAppDialogVisible = true;
      window.localStorage.setItem("download_app_dialog", now);
    }
    /*else if (now - lastShowTime > 86400000) {
      this.downloadAppDialogVisible = true;
      window.localStorage.setItem("download_app_dialog", now);
    }*/
  },
  beforeDestroy() {
    // window.removeEventListener("resize", ()=> this.updateScreenSize(this.$refs.header.offsetWidth));
  },
};
</script>

<style>

.el-container {
  height: 100%;
}

.el-header {
  width: 100%;
  height: 60px;
  line-height: 60px;
  background-color: #FFFFFF;
  box-shadow: 0px 2px 3px #dddddd;
  color: #333;
  z-index: 1001;
}

.el-footer {
  width: 100%;
  background-color: #eeeeee;
  color: #bbbbbb;
  font-size: 10px;
  text-align: center;
  line-height: 30px;
}

.el-footer a:visited {
  color: #bbbbbb;
  text-decoration: none;
}

.el-main {
  width: 100%;
  min-height: 100vh;
  background-color: #ffffff;
  color: #333;
  text-align: center;
  padding: 10px;
}

.el-input-group__append {
  background-color: #409EFF;
  color: #FFFFFF;
  border-radius: 0 20px 20px 0;
  border: #409EFF solid 1px;
}

.el-input__inner {
  border-radius: 20px;
  border: #bbbbbb solid 1px;
}

.input-with-select {
  line-height: 1;
}

.res-type {
  width: 100%;
  height: 30px;
  line-height: 30px;
  font-weight: 600;
  font-size: 15px;
  color: #FFFFFF;
  background: #409EFF;
}

.download-video {
  width: 150px;
  margin-top: 10px;
  display: block;
}

.copy-text {
  width: 250px;
  margin-top: 10px;
  display: block;
}

.checked-icon {
  color: #409EFF;
  font-size: 20px;
  position: absolute;
  padding: 2px;
  right: 0;
  top: 0;
}

.unchecked-icon {
  color: #AAAAAA;
  font-size: 20px;
  position: absolute;
  padding: 2px;
  right: 0;
  top: 0;
}

.hint-text {
  font-size: 10px;
  line-height: 15px;
  color: #888888;
  margin-top: 3px;
  text-align: left;
}

.img-item {
  width: 120px;
  height: 120px;
  margin: 5px;
  position: relative;
  box-shadow: 0 0 3px #333333;
}

.img-item .el-button {
  display: none;
}

.img-item:hover .el-button {
  display: inline;
}

.el-dialog__body {
  padding: 0;
}

.wechat-pay-items {
  width: 100%;
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.wechat-pay-item-choose {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 80px;
  height: 24px;
  border-color: #09BB07;
  border-style: solid;
  border-width: 2px;
  border-radius: 5px;
}

.month-vip-title {
  margin-left: 4px;
  font-size: 15px;
  line-height: 1;
  color: #333333;
}

.month-vip-sub-title {
  margin-left: 4px;
  margin-top: 6px;
  font-size: 12px;
  line-height: 1;
  color: #888888;
}

.month-vip-items {
  width: 400px;
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}

.month-vip-item-choose{
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  flex: 1;
  height: 110px;
  border-color: #FECC56;
  border-style:solid;
  border-width: 2px;
  border-radius: 6px;
  margin-left: 6px;
  margin-right: 6px;
  background: #ffffff;
}
.month-vip-item{
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  flex: 1;
  height: 110px;
  border-color: #E0E0E0;
  border-style:solid;
  border-width: 2px;
  border-radius: 6px;
  margin-left: 6px;
  margin-right: 6px;
  background: #ffffff;
}
.month-vip-text-time{
  height: 30px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size:16px;
  font-weight:500;
  color: #333333;
  text-align: center;
  background: #E0E0E0;
}
.month-vip-text-time-choose{
  height: 30px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size:16px;
  font-weight:500;
  color: #000000;
  text-align: center;
  background: #FECC56;
}
.month-vip-text-recommend{
  width: 60px;
  display:flex;
  flex-direction:column;
  justify-content:center;
  align-items:center;
  font-size: 12px;
  line-height: 18px;
  color: #FFFFFF;
  text-align: center;
  background: #F44336;
  border-radius: 4px;
}
.month-vip-text-money{
  display:flex;
  flex-direction:column;
  justify-content:center;
  align-items:center;
  font-size: 20px;
  font-weight: bold;
  line-height: 28px;
  color: #333333;
  text-align: center;
}
.month-vip-text-orig{
  display:flex;
  flex-direction:column;
  justify-content:center;
  align-items:center;
  font-size: 12px;
  line-height: 18px;
  color: #9E9E9E;
  text-align: center;
}

.app-download-dialog {
  height: 695px;
  width: 750px;
  background-image: url('~@/assets/app_background.jpg');
}

.buy-know-text-area {
  width:300px;
  padding: 0 10px;
  font-size: 12px;
  line-height: 16px;
  color: #333333;
  white-space: pre-wrap;
}

/*.img-item i {
    border:1px solid rgba(0,0,0,0);
}

.img-item:hover i {
    border:1px solid #409EFF;
}*/
</style>
